import React from 'react'
import "../../../styles/archive_recommendation/archive_header.css"

const ArchiveHeader = () => (
    <div className='archive-header'>The Archive</div>
)

export default ArchiveHeader;